import {useEffect, useMemo, useState} from 'react';
import {useCookies} from 'react-cookie';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import HeaderBasketButton from '../../../components/headerBasketButton';
import CustomCarousel from '../../../components/mazraeKit/customCarousel';
import CustomSearchBox from '../../../components/mazraeKit/customSearchBox';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import ChatHeaderIcon from '../../../components/mazraeKit/headers/ChatHeaderIcon/ChatHeaderIcon';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import NotificationHeaderIcon from '../../../components/mazraeKit/headers/NotificationHeaderIcon/NotificationHeaderIcon';
import {useGetSupplierStories} from '../../../components/mazraeKit/story/hooks';
import {useAuth} from '../../../context/authContext';
import Buyers from '../../../module/newShop/home/buyers';
import CategoryCards from '../../../module/newShop/home/inputGroups';
import NearestStores from '../../../module/newShop/home/nearestStores';
import NewestShops from '../../../module/newShop/home/newestShops';
import SelectedBrands from '../../../module/newShop/home/selectedBrands';
import StorySection from '../../../module/newShop/home/StorySection';
import useGetAllBannersImages from '../../../services/hookService/getAllBannerImages/useGetAllBannersImages';
import useGetAllNotifications from '../../../services/hookService/getAllNotification/useGetAllNotifications';
import useGetHomepageLabNotifModal from '../../../services/hookService/getHomepageLabNotifModal/useGetStoreAndLabModal';
import useGetHomepageStoreNotifModal from '../../../services/hookService/getHomepageStoreNotifModal/useGetHomepageStoreNotifModal';
import UseGetProfileCity from '../../../services/hookService/getProfileCityName/useGetProfileCity';
import {RootState} from '../../../store/redux';
import {addRegisterAdvertisement} from '../../../store/redux/advertisementRegisteration';
import {googleAnalyticsInstance} from '../../../utilities/helper/googleAnalitics';
import {groupByField} from '../../../utilities/helper/groupByField';
import useDebounce from '../../../utilities/hooks/useDebounce/useDebounce';
import StoreAndLabResultModal from '../myStore/modal/storeAndLabResultModal';
import {handleStoreAndLabModalTitle} from './constants';
import AdvertisementResultModal from './modals/advertisementResultmodal';

const HomePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [stateValue] = useState<IAddedAdvertisementResponse>(location.state);

  useEffect(() => {
    if (location.state) {
      // Clear state history after first use
      navigate(location.pathname, {replace: true, state: null});
    }
  }, [location, navigate]);

  const {supplierProfile} = useAuth();

  // Fetch supplier with stories
  const {stories: storesWithStory} = useGetSupplierStories();

  const [inputValue, setInputValue] = useState<string>('');
  const debouncedValue = useDebounce(inputValue, 1000);
  const [, , removeCookie] = useCookies(['filter_farm']);

  const [advertisementResultModal, setAdvertisementResultModal] =
    useState(false);

  const [labAndStoreResultModal, setLabAndStoreResultModal] = useState(false);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    removeCookie('filter_farm');
  };
  const {locational} = useSelector(
    (state: RootState) => state.searchingLocation,
  );

  const {data: bannersData} = useGetAllBannersImages({
    type: 'SUPPLIER_MAIN',
  });

  const {notifications} = useGetAllNotifications();

  const {storeModal, isLoading: isStoreModalLoading} =
    useGetHomepageStoreNotifModal();
  const {labModal, isLoading: isLabModalLoading} =
    useGetHomepageLabNotifModal();

  useEffect(() => {
    if (supplierProfile) {
      supplierProfile?.store?.guid || supplierProfile?.lab?.guid
        ? dispatch(
            addRegisterAdvertisement({
              ad_type: {title: 'آگهی فروشگاهی', value: 'store'},
            }),
          )
        : dispatch(
            addRegisterAdvertisement({
              ad_type: {title: 'آگهی شخصی', value: 'personal'},
            }),
          );
    }
  }, [supplierProfile]);

  useEffect(() => {
    setAdvertisementResultModal(false);
    const combinedArray = [
      ...(notifications ? notifications?.advertisement : []),
      ...(notifications ? notifications?.requirement : []),
    ];
    combinedArray.length > 0 && setAdvertisementResultModal(true);
  }, [notifications]);

  useEffect(() => {
    if (storeModal || labModal) {
      setLabAndStoreResultModal(true);
    }
  }, [storeModal?.store || labModal?.lab]);

  useEffect(() => {
    if (!debouncedValue || !inputValue) return;
    navigate('/search-store', {state: {searchValue: inputValue}});
  }, [debouncedValue]);

  // a reduce function to group the banners by their position
  const bannersByPosition = useMemo(() => {
    if (bannersData) return groupByField(bannersData, 'position');
  }, [bannersData]);

  // Access banners like:
  const upBannerData = bannersByPosition?.['home_up'] || [];
  const downBannerData = bannersByPosition?.['home_down'] || [];

  const isLoading = isLabModalLoading || isStoreModalLoading;
  const storeAndLabModal = {...labModal, ...storeModal} as IStoreAndLabModal;
  return (
    <div className="flex relative flex-col w-full h-full">
      <CustomHeader
        title="فروشگاه مزرعه"
        backRoute="/home"
        preComponent={() => <HeaderBasketButton />}
        postComponent={() => (
          <div className="flex gap-3">
            <NotificationHeaderIcon />
            <ChatHeaderIcon />
          </div>
        )}
      />

      <section className="flex overflow-y-auto flex-col w-full h-full">
        {/* ----------------------------------------------------- */}
        {/* ------------------ STORY Section -------------------- */}
        {/* ----------------------------------------------------- */}
        {storesWithStory !== undefined && storesWithStory.length > 0 && (
          // <Stories />
          <StorySection isMain={true} />
        )}
        <div className="bg-white flex flex-col rounded-t-[24px] w-full -mt-5 gap-10">
          <div
            className={`w-full px-3 mt-4 ${
              storesWithStory === undefined || storesWithStory.length === 0
                ? 'pt-10'
                : ''
            }`}
          >
            <CustomSearchBox
              placeholder="جستجو در فروشگاه "
              type="text"
              value={inputValue}
              inputCustomClass="!pr-2"
              preIcon="icon-nameSearch"
              onChange={onChangeHandler}
              showRemoveIcon={false}
              customComponent={() => (
                <div className="flex absolute left-0 top-1/2 items-center px-2 py-2 border-r-2 border-gray-100 -translate-y-1/2">
                  <i className="text-xl icon-nameLocation" />
                  <span
                    className="text-sm"
                    onClick={() => {
                      navigate('/choose-location', {
                        state: {from: location?.pathname},
                      });
                      googleAnalyticsInstance.eventGoogleAnalytics({
                        category: 'chooseLocation',
                        action:
                          'کاربر روی انتخاب شهرهای دیگر در هوم شاپ کلیک کرد',
                      });
                    }}
                  >
                    {locational?.length
                      ? `${locational?.length} شهرستان`
                      : UseGetProfileCity().profileCity}
                  </span>
                </div>
              )}
              {...{inputValue, setInputValue}}
            />
          </div>
          <CategoryCards chooseOneCard={true} />
          <NearestStores />
          <Buyers isShop={false} />
        </div>
        {upBannerData && upBannerData.length > 0 && (
          <div className="px-3 my-6 w-full">
            <CustomCarousel
              isBannerHome={true}
              data={upBannerData?.map(item => {
                return {
                  guid: item?.guid,
                  image: item?.image,
                  isExternal: item?.is_external_url,
                  link: item?.link,
                };
              })}
            />
          </div>
        )}
        <SelectedBrands />
        <NewestShops />

        <div>
          {downBannerData && downBannerData?.length > 0 && (
            <div className="px-3 my-6 w-full">
              <CustomCarousel
                isBannerHome={true}
                data={downBannerData?.map(item => {
                  return {
                    guid: item?.guid ?? '',
                    image: item?.image ?? '',
                    isExternal: item?.is_external_url ?? '',
                    link: item.link ?? '',
                  };
                })}
              />
            </div>
          )}
        </div>
      </section>
      <MainFooter />

      {/* ============================== ADVERTISEMENT MODAL ============================== */}

      {advertisementResultModal && (
        <AdvertisementResultModal
          setAdvertisementResultModal={setAdvertisementResultModal}
          advertisementResultModal={advertisementResultModal}
          notifcaitons={notifications}
          rejectedAd={
            [
              ...(notifications?.advertisement || []),
              ...(notifications?.requirement || []),
            ].filter(item => item.type === 'rejected').length
          }
          stateValue={stateValue}
          totalModal={
            [
              ...(notifications?.advertisement || []),
              ...(notifications?.requirement || []),
            ].length
          }
        />
      )}

      {/* ================================= LAB MODAL ==================================== */}

      {labAndStoreResultModal &&
        !isLoading &&
        storeAndLabModal &&
        Object.keys(storeAndLabModal)?.length > 0 && (
          <StoreAndLabResultModal
            title={
              storeAndLabModal &&
              handleStoreAndLabModalTitle('title', storeAndLabModal)
            }
            desc={
              storeAndLabModal &&
              handleStoreAndLabModalTitle('desc', storeAndLabModal)
            }
            isSuccessModal={labAndStoreResultModal}
            setIsSuccessModal={setLabAndStoreResultModal}
            successBtnTitle="ورود به فروشگاه"
            isEdit={storeAndLabModal?.modal_type === 'rejected'}
            rejectedOnClick={() => setLabAndStoreResultModal(false)}
            removeOnClick={() => setLabAndStoreResultModal(false)}
            editOnClick={() => {
              storeAndLabModal?.lab?.guid
                ? navigate(
                    `/edit-register-store/lab/${storeAndLabModal?.lab?.guid}`,
                    {state: {mode: 'edit', tab: 2}},
                  )
                : navigate(
                    `/edit-register-store/store/${storeAndLabModal?.store?.guid}`,
                    {state: {mode: 'edit', tab: 2}},
                  );
              setLabAndStoreResultModal(false);
            }}
            onSuccessBtnClick={() => {
              if (storeAndLabModal?.store?.guid) {
                navigate(`/shop-card-detail/${storeAndLabModal?.store?.guid}`);
              } else {
                navigate(`/lab-card-detail/${storeAndLabModal?.lab?.guid}`);
              }

              setLabAndStoreResultModal(false);
            }}
          />
        )}
    </div>
  );
};

export default HomePage;
